module.exports = "/_next/static/images/game-1-phone-avatar-mum-0f22f4a2ff83bfef2910e888c1edf4be.jpg";